import { AFF_BALANCE, AFF_WITHDRAWS, AFF_AWARDS } from "store/ActionTypes"
import { Action, AffBalance, AffWithdraws, AffAwards } from "types/interface"

export interface AffiliateState {
  [AFF_BALANCE]: AffBalance | null,
  [AFF_WITHDRAWS]: AffWithdraws | null,
  [AFF_AWARDS]: AffAwards | null,
}

const defaultState: AffiliateState = {
  [AFF_BALANCE]: null,
  [AFF_WITHDRAWS]: null,
  [AFF_AWARDS]: null
}

export default (state = defaultState, action: Action) => {
  const {type, value} = action
  const old_value = state[type]

  if (old_value !== undefined) {
    return {
      ...state,
      [type]: value
    }
  }
  return state
}
